import { useContext } from "react";
import { MediaContext } from "../providers/MediaProvider";

export const useMedia = () => useContext(MediaContext);
